<template>
  <div
    class="wheel-battle-parent-detail"
    :class="{ 'wheel-battle-parent-detail--no-footer': !showPageFooter }"
  >
    <div class="detail-top">
      <wheel-battle-detail-header
        :sequence-no="detail.sequenceNo"
        :group-name="detail.groupName"
        :status="detail.status"
        :status-label="detail.statusLabel"
      />

      <van-tabs v-model="activeTab" class="detail-tabs">
        <van-tab title="基本信息" name="basic">
          <div class="tab-panel">
            <wheel-battle-basic-info-form
              v-model="form"
              :rules="rules"
              :show-group="false"
              :editable="isBasicEditable"
              :union-match-id="unionMatchId"
              :match-id="matchId"
            />
          </div>
        </van-tab>
        <van-tab title="设置队伍" name="teams">
          <div class="tab-panel">
            <wheel-battle-teams-tab
              :parent-game-id="parentGameId"
              :union-match-id="unionMatchId"
              :match-id="matchId"
              :match-logo="matchLogo"
              :group-name="detail.groupName"
              :teams="participatingTeams"
              :editable="isTeamsEditable"
              :jersey-editable="isJerseyColorEditable"
              @select-jersey="onSelectJersey"
            />
          </div>
        </van-tab>
        <van-tab title="录入比分" name="score">
          <div class="tab-panel">
            <wheel-battle-score-tab
              ref="scoreTab"
              :parent-game-id="parentGameId"
              :match-logo="matchLogo"
              :teams="rotationTeams"
              :sub-matches="subMatches"
              :current-sub-match="currentSubMatch"
              :parent-ended="detail.status === 'ended'"
              @create-sub-match="onCreateSubMatch"
              @record-score="onRecordScore"
              @request-create="onScoreNew"
            />
          </div>
        </van-tab>
        <van-tab title="实时排名" name="rank">
          <div class="tab-panel">
            <wheel-battle-rank-tab :standing="standing" :match-logo="matchLogo" />
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 录入比分 Tab 底部 -->
    <div v-if="activeTab === 'score'" class="footer">
      <div class="footer-inner score-footer">
        <div
          v-if="showWheelEndAction"
          class="wheel-end-action"
          @click="onWheelEnd"
        >
          <img class="wheel-end-icon" :src="wheelEndIconUrl" alt="" />
          <span>车轮结束</span>
        </div>
        <div v-else class="footer-spacer" />
        <van-button
          type="primary"
          round
          class="submit-btn"
          :class="{ 'submit-btn-disabled': hasUnrecordedSubMatch }"
          @click="onScoreNew"
        >
          新建
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>

    <!-- 基本信息 Tab 底部 -->
    <div v-else-if="activeTab === 'basic'" class="footer">
      <div class="footer-inner">
        <div class="footer-actions">
          <div class="action-item" @click="onDelete">
            <img class="action-icon" :src="deleteIconUrl" alt="" />
            <span>删除</span>
          </div>
          <div v-if="isParentEnded" class="action-item" @click="onRestart">
            <img class="action-icon" :src="restartIconUrl" alt="" />
            <span>重启</span>
          </div>
          <div class="action-item" @click="onBigScreen">
            <img class="action-icon" :src="screenIconUrl" alt="" />
            <span>大屏</span>
          </div>
        </div>
        <van-button
          type="primary"
          round
          class="submit-btn"
          :loading="submitting"
          @click="onSubmit"
        >
          提交
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>

    <van-overlay :show="showSubMatchSuccessDialog" :z-index="2000">
      <div class="success-dialog-wrap">
        <div class="success-dialog">
          <div class="dialog-title">提示</div>
          <div class="dialog-message">比赛创建成功，是否立即编辑比分</div>
          <div class="dialog-actions">
            <div class="dialog-btn dialog-btn-primary" @click="onEditScoreNow">立即编辑</div>
            <div class="dialog-divider" />
            <div class="dialog-btn" @click="onSkipEditScore">暂不编辑</div>
          </div>
        </div>
      </div>
    </van-overlay>

    <van-overlay :show="showRestartConfirmDialog" :z-index="2000">
      <div class="success-dialog-wrap">
        <div class="success-dialog">
          <div class="dialog-title">提示</div>
          <div class="dialog-message dialog-message--restart">
            <p class="dialog-message-line">车轮赛已结束</p>
            <p class="dialog-message-line">创建新比赛车轮赛会重新开启</p>
          </div>
          <div class="dialog-actions">
            <div class="dialog-btn dialog-btn-primary" @click="onRestartConfirm">确认，继续创建</div>
            <div class="dialog-divider" />
            <div class="dialog-btn" @click="onRestartCancel">取消</div>
          </div>
        </div>
      </div>
    </van-overlay>

    <wheel-battle-jersey-color-picker
      v-model="showJerseyColorPicker"
      @select="onJerseyColorSelect"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Icon, Button, Toast, Dialog, Overlay } from 'vant'
Vue.use(Tabs).use(Tab).use(Icon).use(Button).use(Toast).use(Dialog).use(Overlay)

import WheelBattleDetailHeader from './components/WheelBattleDetailHeader.vue'
import WheelBattleBasicInfoForm from './components/WheelBattleBasicInfoForm.vue'
import WheelBattleTeamsTab from './components/WheelBattleTeamsTab.vue'
import WheelBattleScoreTab from './components/WheelBattleScoreTab.vue'
import WheelBattleRankTab from './components/WheelBattleRankTab.vue'
import WheelBattleJerseyColorPicker from './components/WheelBattleJerseyColorPicker.vue'
import {
  adminGetBMMatchWheelBattleParentGame,
  adminUpdateBMMatchWheelBattleParentGame,
  adminDeleteBMMatchWheelBattleParentGame,
  adminCreateBMMatchWheelBattleChildGame,
  adminFinishBMMatchWheelBattleParentGame,
  adminRestartBMMatchWheelBattleParentGame,
  adminUpdateBMMatchWheelBattleParentGameTeamClothesColor
} from '@/api/wheel-battle'
import { pageStateFromApiDetail } from '@/api/wheel-battle/adapter'
import {
  buildUpdateParentGameParams,
  buildUpdateTeamClothesColorParams,
  buildCreateChildGameParams,
  buildFinishParentGameParams,
  buildRestartParentGameParams
} from './utils/api-params'
import { resolveApiClothesColor } from './utils/jersey-colors'

export default {
  name: 'WheelBattleParentDetail',
  components: {
    WheelBattleDetailHeader,
    WheelBattleBasicInfoForm,
    WheelBattleTeamsTab,
    WheelBattleScoreTab,
    WheelBattleRankTab,
    WheelBattleJerseyColorPicker
  },
  data: function () {
    return {
      parentGameId: '',
      unionMatchId: '',
      matchId: '',
      matchLogo: '',
      activeTab: 'basic',
      detail: {},
      form: {},
      rules: {},
      participatingTeams: [],
      rotationTeams: [],
      subMatches: [],
      currentSubMatch: null,
      standing: [],
      submitting: false,
      showSubMatchSuccessDialog: false,
      showRestartConfirmDialog: false,
      pendingSubMatchId: '',
      showJerseyColorPicker: false,
      jerseyColorTargetTeamId: '',
      savingJerseyColor: false,
      deleteIconUrl: 'https://images.snsports.cn/FtMssx-c8z4M-6Iy-jYyogliaIyL',
      restartIconUrl: 'https://images.snsports.cn/Fih1XmfekkEotggnom_YS3T0SIn0',
      screenIconUrl: 'https://images.snsports.cn/FubZRg7tL2LHZkcDJ4zvYPY8azQY',
      wheelEndIconUrl: 'https://images.snsports.cn/FmnT0GNMpP2DuAE7PT6ya1xYHRX8'
    }
  },
  computed: {
    showPageFooter: function () {
      return this.activeTab === 'basic' || this.activeTab === 'score'
    },
    isBasicEditable: function () {
      return this.detail.status === 'notStarted'
    },
    isTeamsEditable: function () {
      return this.detail.status === 'notStarted'
    },
    isJerseyColorEditable: function () {
      return this.detail.status !== 'ended'
    },
    hasUnrecordedSubMatch: function () {
      return this.scoreTabState === 'inProgress'
    },
    activeSubMatch: function () {
      return this.currentSubMatch || null
    },
    scoreTabState: function () {
      if (this.activeSubMatch) {
        return 'inProgress'
      }
      if (!this.subMatches.length) {
        return 'empty'
      }
      return 'allCompleted'
    },
    canCreateSubMatch: function () {
      if (this.detail.status === 'ended') {
        return true
      }
      return this.scoreTabState !== 'inProgress'
    },
    isParentEnded: function () {
      return this.detail.status === 'ended'
    },
    showWheelEndAction: function () {
      return this.scoreTabState === 'allCompleted' && this.detail.status !== 'ended'
    },
    screenUrl: function () {
      if (!this.parentGameId) {
        return ''
      }
      return 'https://saas-v2.snsports.cn/#/wheel-battle-screen?gameId=' + this.parentGameId
    }
  },
  mounted: function () {
    this.parentGameId = this.$route.params.parentGameId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.matchId = this.$route.query.matchId || ''
    this.syncTabFromRoute()
    this.loadDetail()
    var self = this
    this.$nextTick(function () {
      self.handleScoreEntryReturn()
    })
  },
  activated: function () {
    this.syncTabFromRoute()
    if (this.parentGameId) {
      this.loadDetail()
      this.handleScoreEntryReturn()
    }
  },
  methods: {
    syncTabFromRoute: function () {
      var tab = this.$route.query.tab
      if (tab) {
        this.activeTab = tab
      }
    },
    handleScoreEntryReturn: function () {
      var showEditScore = this.$route.query.showEditScore
      if (!showEditScore) {
        return
      }
      this.activeTab = 'score'
      this.pendingSubMatchId = showEditScore
      var self = this
      this.$nextTick(function () {
        self.showSubMatchSuccessDialog = true
        self.$router.replace({
          path: '/match-manage/wheel-battle/parent-detail/' + self.parentGameId,
          query: {
            unionMatchId: self.unionMatchId,
            matchId: self.matchId,
            tab: 'score'
          }
        })
      })
    },
    loadDetail: function () {
      var self = this
      return adminGetBMMatchWheelBattleParentGame({
        gameId: self.parentGameId
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '加载失败')
          return
        }
        var page = pageStateFromApiDetail(res && res.data)
        if (page) {
          self.applyPageState(page)
          return
        }
        Toast('加载失败')
      }).catch(function () {
        Toast('加载失败')
      })
    },
    applyPageState: function (page) {
      var prevTeamColors = {}
      ;(this.participatingTeams || []).forEach(function (team) {
        if (team && team.id && team.clothesColor) {
          prevTeamColors[String(team.id)] = team.clothesColor
        }
      })

      this.detail = page.legacy || {}
      this.form = Object.assign({}, page.form || {})
      this.rules = Object.assign({}, page.rules || {})
      this.participatingTeams = (page.participatingTeams || []).map(function (team) {
        if (!team || team.clothesColor || !prevTeamColors[String(team.id)]) {
          return team
        }
        return Object.assign({}, team, { clothesColor: prevTeamColors[String(team.id)] })
      })
      this.rotationTeams = (page.rotationTeams || page.participatingTeams || []).map(function (team) {
        if (!team || team.clothesColor || !prevTeamColors[String(team.id)]) {
          return team
        }
        return Object.assign({}, team, { clothesColor: prevTeamColors[String(team.id)] })
      })
      this.subMatches = page.subMatches || []
      this.currentSubMatch = page.currentSubMatch || null
      this.standing = page.standing || []
      var apiMatchId = page.apiDetail &&
        page.apiDetail.parentGame &&
        page.apiDetail.parentGame.matchId
      if (apiMatchId && !this.matchId) {
        this.matchId = String(apiMatchId)
      }
      this.matchLogo = page.unionMatchIcon || ''
    },
    validateForm: function () {
      if (!this.form.beginDate) {
        Toast('请选择时间')
        return false
      }
      if (!this.form.stadiumName || !String(this.form.stadiumName).trim()) {
        Toast('请输入球场')
        return false
      }
      if (!this.form.pitchId) {
        Toast('请选择场地')
        return false
      }
      return true
    },
    onSubmit: function () {
      if (!this.isBasicEditable) {
        Toast('比赛已开始，无法修改基本信息')
        return
      }
      if (!this.validateForm()) {
        return
      }
      var self = this
      this.submitting = true
      var params = buildUpdateParentGameParams({
        gameId: self.parentGameId,
        form: self.form,
        teams: self.participatingTeams,
        name: self.detail.parentGameName
      })
      adminUpdateBMMatchWheelBattleParentGame(params).then(function (res) {
        self.submitting = false
        if (res && res.error) {
          Toast(res.msg || '保存失败，请稍后重试')
          return
        }
        Toast.success('保存成功')
        self.loadDetail()
      }).catch(function () {
        self.submitting = false
        Toast('保存失败，请稍后重试')
      })
    },
    onDelete: function () {
      var self = this
      Dialog.confirm({
        title: '删除比赛',
        message: '确定删除该车轮战比赛吗？此操作不可恢复。'
      }).then(function () {
        return adminDeleteBMMatchWheelBattleParentGame({
          gameId: self.parentGameId
        })
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '删除失败')
          return
        }
        Toast.success('已删除')
        self.$router.back()
      }).catch(function () {})
    },
    onRestart: function () {
      if (!this.isParentEnded) {
        Toast('仅已结束的车轮战可重启')
        return
      }
      this.confirmRestartAndOpenCreate()
    },
    onBigScreen: function () {
      var self = this
      if (!this.screenUrl) {
        Toast('暂无大屏链接')
        return
      }
      Dialog.confirm({
        title: '大屏',
        message: '大屏展示链接：' + this.screenUrl,
        confirmButtonText: '复制链接',
        cancelButtonText: '取消'
      }).then(function () {
        self.copyScreenUrl(self.screenUrl)
      }).catch(function () {})
    },
    copyScreenUrl: function (text) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text).then(function () {
          Toast.success('复制成功')
        }).catch(function () {
          Toast.fail('复制失败')
        })
        return
      }
      var input = document.createElement('textarea')
      input.value = text
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'absolute'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        Toast.success('复制成功')
      } catch (e) {
        Toast.fail('复制失败')
      }
      document.body.removeChild(input)
    },
    onSelectJersey: function (team) {
      if (!this.isJerseyColorEditable || !team || !team.id) {
        return
      }
      this.jerseyColorTargetTeamId = String(team.id)
      this.showJerseyColorPicker = true
    },
    onJerseyColorSelect: function (color) {
      var teamId = this.jerseyColorTargetTeamId
      if (!teamId) {
        return
      }
      var normalizedColor = resolveApiClothesColor(color)
      var teams = this.participatingTeams.slice()
      var index = -1
      for (var i = 0; i < teams.length; i++) {
        if (String(teams[i].id) === teamId) {
          index = i
          break
        }
      }
      if (index === -1) {
        return
      }
      teams[index] = Object.assign({}, teams[index], { clothesColor: normalizedColor })
      this.participatingTeams = teams
      this.syncTeamClothesColor(teamId, normalizedColor)
      this.saveTeamClothesColor(teamId, normalizedColor)
    },
    syncTeamClothesColor: function (teamId, color) {
      this.rotationTeams = (this.rotationTeams || []).map(function (team) {
        if (String(team.id) === String(teamId)) {
          return Object.assign({}, team, { clothesColor: color })
        }
        return team
      })
    },
    saveTeamClothesColor: function (teamId, color) {
      var self = this
      if (self.savingJerseyColor) {
        return
      }
      self.savingJerseyColor = true
      adminUpdateBMMatchWheelBattleParentGameTeamClothesColor(
        buildUpdateTeamClothesColorParams({
          gameId: self.parentGameId,
          teamId: teamId,
          clothesColor: color || ''
        })
      ).then(function (res) {
        self.savingJerseyColor = false
        if (!res || res.error) {
          Toast((res && res.msg) || '保存队服颜色失败')
          return
        }
        Toast.success('已保存')
        self.loadDetail()
      }).catch(function () {
        self.savingJerseyColor = false
        Toast('保存队服颜色失败')
      })
    },
    openCreateSubMatchPopup: function () {
      this.activeTab = 'score'
      var self = this
      this.$nextTick(function () {
        if (self.$refs.scoreTab) {
          self.$refs.scoreTab.openCreatePopup()
        }
      })
    },
    confirmRestartAndOpenCreate: function () {
      this.showRestartConfirmDialog = true
    },
    onRestartCancel: function () {
      this.showRestartConfirmDialog = false
    },
    onRestartConfirm: function () {
      var self = this
      this.showRestartConfirmDialog = false
      adminRestartBMMatchWheelBattleParentGame(
        buildRestartParentGameParams({
          gameId: self.parentGameId
        })
      ).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '重启失败')
          return Promise.reject(new Error('restartFailed'))
        }
        return self.loadDetail()
      }).then(function () {
        self.openCreateSubMatchPopup()
      }).catch(function () {})
    },
    onScoreNew: function () {
      if (this.isParentEnded) {
        this.confirmRestartAndOpenCreate()
        return
      }
      if (this.hasUnrecordedSubMatch) {
        Toast('请先录入上一场比赛比分')
        return
      }
      this.openCreateSubMatchPopup()
    },
    onCreateSubMatch: function (payload) {
      var self = this
      if (this.$refs.scoreTab) {
        this.$refs.scoreTab.setCreateSubmitting(true)
      }
      var params = buildCreateChildGameParams({
        gameId: self.parentGameId,
        payload: payload
      })
      adminCreateBMMatchWheelBattleChildGame(params).then(function (res) {
        if (self.$refs.scoreTab) {
          self.$refs.scoreTab.setCreateSubmitting(false)
          self.$refs.scoreTab.closeCreatePopup()
        }
        if (res && res.error) {
          Toast(res.msg || '创建失败，请稍后重试')
          return
        }
        var createdId = res && res.data && res.data.id
        self.pendingSubMatchId = createdId || ''
        self.loadDetail()
        if (self.pendingSubMatchId) {
          self.showSubMatchSuccessDialog = true
        }
      }).catch(function () {
        if (self.$refs.scoreTab) {
          self.$refs.scoreTab.setCreateSubmitting(false)
        }
        Toast('创建失败，请稍后重试')
      })
    },
    onRecordScore: function (subMatch) {
      if (!subMatch || !subMatch.id) {
        return
      }
      this.goScoreEntry(subMatch.id)
    },
    onEditScoreNow: function () {
      this.showSubMatchSuccessDialog = false
      if (this.pendingSubMatchId) {
        this.goScoreEntry(this.pendingSubMatchId)
      }
    },
    onSkipEditScore: function () {
      this.showSubMatchSuccessDialog = false
    },
    goScoreEntry: function (subMatchId) {
      this.$router.push({
        path: '/match-manage/wheel-battle/score-entry/' + this.parentGameId + '/' + subMatchId,
        query: { unionMatchId: this.unionMatchId }
      })
    },
    onWheelEnd: function () {
      var self = this
      Dialog.confirm({
        title: '车轮结束',
        message: '确定结束本场车轮战吗？'
      }).then(function () {
        return adminFinishBMMatchWheelBattleParentGame(
          buildFinishParentGameParams({
            gameId: self.parentGameId
          })
        )
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '操作失败')
          return
        }
        Toast.success('已结束')
        self.loadDetail()
      }).catch(function () {})
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-parent-detail {
  min-height: 100vh;
  background: #f1f1f1;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));

  &--no-footer {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

.detail-top {
  background: #fff;
}

.detail-tabs {
  ::v-deep .van-tabs__wrap {
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
  }

  ::v-deep .van-tab {
    font-size: 14px;
    color: #666;
  }

  ::v-deep .van-tab--active {
    color: #2071b9;
    font-weight: 500;
  }

  ::v-deep .van-tabs__line {
    width: 24px !important;
    height: 3px;
    background-color: #2071b9;
    border-radius: 2px;
    bottom: 15px;
  }

  ::v-deep .van-tabs__content {
    background: #f1f1f1;
  }
}

.tab-panel {
  min-height: 200px;
}

.tab-placeholder {
  padding: 40px 16px;
  text-align: center;
  color: #999999;
  font-size: 14px;
  background: #f1f1f1;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
}

.footer-inner {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.score-footer {
  min-height: 40px;
}

.footer-spacer {
  flex: 1;
}

.footer-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.footer-actions {
  display: flex;
  align-items: center;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  margin-right: 16px;
  font-size: 11px;
  color: #666;

  span {
    margin-top: 2px;
  }
}

.action-icon {
  width: 21px;
  height: 21px;
  display: block;
}

.wheel-end-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  font-size: 11px;
  color: #ee0a24;

  span {
    margin-top: 2px;
  }
}

.wheel-end-icon {
  width: 16px;
  height: 16px;
  display: block;
}

.submit-btn {
  min-width: 120px;
  height: 40px;
  background: #337ecc;
  border-color: #337ecc;
}

.submit-btn-disabled {
  opacity: 0.45;
}

.success-dialog-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 40px;
}

.success-dialog {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  text-align: center;
}

.dialog-title {
  padding: 24px 20px 0;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
}

.dialog-message {
  padding: 12px 20px 24px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.dialog-message--restart {
  padding: 16px 24px 28px;
}

.dialog-message-line {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 22px;

  & + & {
    margin-top: 6px;
  }
}

.dialog-actions {
  border-top: 1px solid #ebedf0;
}

.dialog-btn {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #333;
  background: #fff;

  &:active {
    background: #f2f3f5;
  }
}

.dialog-btn-primary {
  color: #337ecc;
  font-weight: 500;
}

.dialog-divider {
  height: 1px;
  background: #ebedf0;
}
</style>
